module.exports = __webpack_public_path__ + "static/media/check-green.630123fa.svg";